import { Component, OnInit } from '@angular/core';
import { StateService, User, WorkDay } from '../../public-api';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ModalRole } from '../models/modal-roles';

@Component({
  selector: 'lib-export-popup',
  templateUrl: './export-popup.component.html',
  styleUrls: ['./export-popup.component.scss'],
  standalone: false,
})
export class ExportPopupComponent implements OnInit {
  public monthYearLabel: string;
  public selectedUserNames = new Set<string>();
  public users: User[];
  private subs: Subscription[] = [];
  public month: number;
  public year: number;
  public monthHasUnapprovedEntries: boolean = false;

  constructor(public state: StateService, private modalCtrl: ModalController) {}

  ngOnInit() {
    this.subs.push(
      this.state.users$.subscribe(
        (x) => (this.users = x.filter((y) => !y.isDeleted))
      )
    );
    this.subs.push(
      this.state.workingDays$.subscribe((x) => {
        this.monthHasUnapprovedEntries = this.hasUnapprovedEntries(
          x,
          this.month + 1,
          this.year
        );
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((x) => x.unsubscribe());
  }

  private parseDateSafe(dateStr?: string): Date | null {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  }
  private hasUnapprovedEntries(
    workDays: WorkDay[],
    month: number,
    year: number
  ): boolean {
    return workDays.some((wd) => {
      const dayDate = this.parseDateSafe(wd.workingDate ?? undefined);
      if (!dayDate) return false;
      if (dayDate.getMonth() + 1 !== month || dayDate.getFullYear() !== year)
        return false;
      const entries = wd.workEntries ?? [];
      return entries.some((e) => !e.approvedBy);
    });
  }

  close() {
    this.modalCtrl.dismiss(null, ModalRole.Cancel);
  }

  // Einzel-Auswahl
  toggleSelection(userName: string, checked: boolean) {
    if (checked) {
      this.selectedUserNames.add(userName);
    } else {
      this.selectedUserNames.delete(userName);
    }
  }

  isSelected(userName: string): boolean {
    return this.selectedUserNames.has(userName);
  }

  // Master-Checkbox
  isAllSelected(): boolean {
    return (
      this.selectedUserNames.size === this.users.length && this.users.length > 0
    );
  }

  toggleAll(checked: boolean) {
    if (checked) {
      this.users.forEach((u) => this.selectedUserNames.add(u.userName));
    } else {
      this.selectedUserNames.clear();
    }
  }

  exportSelected() {
    this.modalCtrl.dismiss(
      Array.from(this.selectedUserNames),
      ModalRole.Confirm
    );
  }
}
